import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ScheduleService } from '../../services';
import { HEATING_SCHEDULE_LEVEL } from '../../schedule.enums';

@Component({
  selector: 'app-program',
  templateUrl: './program.component.html',
  styleUrls: ['./program.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgramComponent {
  readonly totalMins = 1440;
  readonly totalHeight = 540;

  @Input()
  scheduleId;
  @Input()
  duration = 100;
  @Input()
  program = 'default';
  @Input()
  start;
  readonly HEATING_SCHEDULE_LEVEL = HEATING_SCHEDULE_LEVEL;

  constructor(public scheduleService: ScheduleService) {}

  get programCss(): string {
    return this.program ? 'program-' + this.program.replace(/\//gm, '-') : 'program-default';
  }

  calcHeight(): number {
    return (this.duration * this.totalHeight) / this.totalMins;
  }
}
